import React from 'react'
import { useDispatch } from 'react-redux'
import MultiCheckbox from '../MultiCheckbox'

const MUInvoiceList = (props) => {
    const { invoiceDataList, updateInvoiceHeader } = props
    const dispatch = useDispatch()
    const toggleSelection = (e, { id, label, checked }) => {
        dispatch(updateInvoiceHeader({ invoiceId: id, data: { checked: checked } }))
    }

    return (
        <MultiCheckbox
            className='dropdown-checkbox__icon'
            label={'INVOICES'}
            itemList={invoiceDataList}
            toggleSelection={toggleSelection}
        />
    )
}

export default MUInvoiceList